import Vue from 'vue'
import App from './App.vue'
import { sync } from 'vuex-router-sync'
// import router from './router'
// import store from './store'
import router from '@/router'
import store from '@/store'
import './registerServiceWorker'
import axios from 'axios';
import VueSweetalert2 from 'vue-sweetalert2'
import Popover from 'vue-js-popover'
import Datetime from 'vue-datetime'
import { Settings } from 'luxon'
import 'vue-datetime/dist/vue-datetime.css'
import 'vue-search-select/dist/VueSearchSelect.css'
//import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import Notifications from 'vue-notification'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import vmodal from 'vue-js-modal'
import VueI18n from 'vue-i18n'
import packLaguages from '@/lang'
import {ColorPicker, ColorPanel} from 'one-colorpicker'
import vClickOutside from 'v-click-outside'

// en | es => idioma por default del sistema
window.langLocal = (localStorage.getItem('langLocal')!=null) ? localStorage.getItem('langLocal') : 'en' ; //en | es 
window.showLang = (localStorage.getItem('showLang')!=null) ? localStorage.getItem('showLang') : 'Off' ; //On | Off
Settings.defaultLocale = window.langLocal
const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}
Vue.use(vClickOutside)
Vue.use(ColorPanel)
Vue.use(ColorPicker)
Vue.use(VueI18n)
Vue.component('multiselect', Multiselect)
Vue.use(Popover)
Vue.use(vmodal)
Vue.use(VueSweetalert2, options)
Vue.use(Datetime)
Vue.use(Notifications)
Vue.config.productionTip = false
Vue.config.devtools = true
if(localStorage.getItem('langLocal')==null){localStorage.setItem('langLocal', window.langLocal);}
window.laguages = packLaguages;
// console.log('laguages', window.laguages);
window.messages = {
  "en": {lang: window.laguages.en},
  "es": {lang: window.laguages.es}
}
const i18n = new VueI18n({
  locale: window.langLocal, // set locale
  // eslint-disable-next-line no-undef
  messages, // set locale messages
})

window.lang2= window.messages[window.langLocal].lang // declaracion para usar lang en js

window.localtoken_M = localStorage.getItem('access_token_m'); //token master
window.localtoken = localStorage.getItem('access_token'); // token billing
window.localAccountID = localStorage.getItem('mark_client_data_m');// user_id
window.localuserdata = localStorage.getItem('mark_client_data'); // org_id
window.localorgdata = localStorage.getItem('mark_client_data'); // org_id
window.master_client = localStorage.getItem('master_client_data'); // master_user_id           
window.user_type = localStorage.getItem('user_type'); // user_type
Vue.prototype.$localtoken = window.localtoken_M;

//url de produccion dimenu 
var DiMenu = new Array();
DiMenu['urlmaster'] ='https://m.dimenu.com/'; 
DiMenu['urlbaselogin'] ='https://dimenu.com/login'; 
DiMenu['urlweb'] ='https://r.dimenu.com/'; 
DiMenu['urlDisplay'] ='https://d.dimenu.com/'; 
DiMenu['urlbase'] =''; 
//url de produccion dimenu Peru
var DiMenuPeru = new Array();
DiMenuPeru['urlmaster'] ='https://m.dimenuperu.com/'; 
DiMenuPeru['urlbaselogin'] ='https://dimenuperu.com/login'; 
DiMenuPeru['urlweb'] ='https://dimenuperu.com/'; 
DiMenuPeru['urlDisplay'] ='https://d.dimenuperu.com/'; 
DiMenuPeru['urlbase'] =''; 
//url de DEV BETA
var BETA = new Array();
BETA['urlmaster'] ='https://dimenumaster.marketeabeta.com/'; 
BETA['urlbaselogin'] ='https://dimenu.marketeabeta.com/login'; 
BETA['urlweb'] ='https://dimenu.marketeabeta.com/';
BETA['urlDisplay'] ='https://mdisplayperu.marketeabeta.com/';  
BETA['urlbase'] =''; 
//url de DEV LOCAL
var LOCAL = new Array();
LOCAL['urlmaster'] ='http://127.0.0.1:8000/'; 
LOCAL['urlbaselogin'] ='http://localhost:8080/'; 
LOCAL['urlweb'] ='http://127.0.0.1:8000/'; 
LOCAL['urlDisplay'] ='https://mdisplayperu.marketeabeta.com/';  
LOCAL['urlbase'] =''; 
var CNX = new Array();
CNX['DiMenu'] = DiMenu;
CNX['DiMenuPeru'] = DiMenuPeru;
CNX['BETA'] = BETA;
CNX['LOCAL'] = LOCAL;

//OPCIONES DE CONEXION = DiMenu / IDIOMA = en | DiMenuPeru / IDIOMA = es  | BETA | LOCAL
var cnx_server = 'DiMenu';
//url de conexion 
window.urlmaster = CNX[cnx_server]['urlmaster'];
window.urlbaselogin = CNX[cnx_server]['urlbaselogin'];
window.urlweb = CNX[cnx_server]['urlweb'];
window.urlbase = CNX[cnx_server]['urlbase'];
// debugger;
window.urlDisplay = CNX[cnx_server]['urlDisplay'];
window.emailVerify=true;

window.masterApiv2 = axios.create({baseURL: window.urlmaster+ 'api/v2/'});
window.master = axios.create({
  baseURL: window.urlmaster + 'api/v3/',
  headers: {
    'common': {'Authorization': 'Bearer'+window.localtoken_M},
    'post': {'Content-Type': 'application/json'}    
  }
});
//window.master = axios.create({baseURL: window.urlmaster+ 'api/v3/'});
//window.master.defaults.headers.post['Content-Type'] = 'application/json'
window.master.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token_m')



window.apiv2 = axios.create({baseURL: window.urlbase+ 'api/v2/'});
window.billing = axios.create({
  baseURL: window.urlbase + 'api/v3/',
  headers: {
    'common': {'Authorization': 'Bearer'+window.localtoken},
    'post': {'Content-Type': 'application/json'}    
  }
});
//window.billing.defaults.baseURL = window.urlbase + 'api/v3/'
//window.billing.defaults.headers.post['Content-Type'] = 'application/json'
window.billing.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token')



Vue.filter('formatMoney', (value) => {
  return Number(value)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
});
Vue.filter('formatMileage', (value) => {
  return Math.trunc(value)
      .toFixed()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
});
sync(store, router)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

